import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { requireFeature } from '@/common/utils/requireFeature';
import { FeatureKey } from '@/common/enums/feature-keys.enum';
import { PermissionGate } from '@/components/PermissionGate';
import { Permission } from '@/common/enums/permissions.enum';
import { PlaybookWizard } from '@/features/playbooks/components/PlaybookWizard';

const searchSchema = z.object({
  editId: z.string().optional(),
  templateId: z.string().optional(),
});

export const Route = createFileRoute('/_authenticated/playbooks/new')({
  validateSearch: searchSchema,
  beforeLoad: async () => {
    await requireFeature(FeatureKey.CLIENT_PLAYBOOKS);
  },
  component: PlaybookNewPage,
});

function PlaybookNewPage() {
  const { editId, templateId } = Route.useSearch();
  return (
    <PermissionGate permission={Permission.PLAYBOOKS_CREATE}>
      <PlaybookWizard editId={editId} templateId={templateId} />
    </PermissionGate>
  );
}
